<template>
  <v-card
    class="mx-3 mb-5"
    max-width="300"
    dark
  >
    <v-img
        class="white--text align-end"
        height="200px"
        src="https://media3.giphy.com/media/VbnUQpnihPSIgIXuZv/giphy.webp?cid=ecf05e47s09d7ug75akqrh4jzx1btdq9vzogvqrtifwodm91&rid=giphy.webp&ct=g" 
      >
        <v-card-title text="purple lighten-3">Tomcat Servering BlackJack</v-card-title>
    </v-img>

    <v-card-text>
        <div>BUILT WITH.</div>
        <div div>Java, Tomcat and JavaScript</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="purple lighten-3"
        text
        href="https://github.com/rogieBeer/pub-tc-blackjack"
      >
        CODE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: "ProjectCard6"

}
</script>

<style scoped>

</style>